"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailPathRequest = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const emailTypes_1 = tslib_1.__importDefault(require("./enums/emailTypes"));
class EmailPathRequest extends base_models_1.Serializable {
}
exports.EmailPathRequest = EmailPathRequest;
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ name: 'type' }),
    (0, base_models_1.Docs)({ description: 'which email to render', example: 'enrichment' }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(emailTypes_1.default),
    tslib_1.__metadata("design:type", String)
], EmailPathRequest.prototype, "type", void 0);
